// extracted by mini-css-extract-plugin
export default {"popup":"ModalOverlay_popup__BeFNc","flareAnimation":"ModalOverlay_flareAnimation__0B6Pr"};